import Class from "./Class";
import TypeUtil from "./TypeUtils";

/**
 * utility for doing basic xhr things that don't correspond
 * to a particular CW service (graphql, upload, etc)
 */

export default class XhrUtil {

	public static getJson<T = any>(uri: string, become?: Class<T>): Promise<T> {

		const xhr = new XMLHttpRequest();

		const promise = new Promise<T>((resolve, reject) => {

			xhr.onreadystatechange = () => {
				if (xhr.readyState === 4) {

					if (xhr.status === 200) {
						try {
							const data = JSON.parse(xhr.responseText);
							resolve(typeof become === 'function' ? TypeUtil.become(data, become) : data);
						} catch (e) {
							reject(e);
						}
						return;
					}

					reject(xhr.responseText);
				}
			};

		});

		xhr.open('GET', uri, true);

		xhr.send();

		return promise;
	}

	public static getXml(uri: string): Promise<XMLDocument> {

		const xhr = new XMLHttpRequest();

		const promise = new Promise<XMLDocument>((resolve, reject) => {

			xhr.onreadystatechange = () => {
				if (xhr.readyState === 4) {

					if (xhr.status === 200) {
						resolve(xhr.responseXML);
						return;
					}

					reject(xhr.responseText);
				}
			};

		});

		xhr.overrideMimeType('text/xml');

		xhr.open('GET', uri, true);

		xhr.send();

		return promise;
	}
}



// WEBPACK FOOTER //
// ./src/core/util/XhrUtil.ts